
export default {
  props: {
    stats: {
      type: [Object, Array],
      default: null,
    },
    statGroup: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getStatValues (stat) {
      const statName = this.getStatName(stat.stat);

      if (statName) {
        const values = [];
        if (this.stats[0] && this.stats[0][statName]) {
          values.push(this.stats[0][statName].value);
        }
        if (this.stats[1] && this.stats[1][statName]) {
          values.push(this.stats[1][statName].value);
        }
        return values;
      }
    },
    getStatName (stat) {
      return stat.playerstattype.length
        ? stat.playerstattype[0].displayName
        : stat.computedplayerstattype.length
          ? stat.computedplayerstattype[0].displayName
          : null;
    },
    getStatTitle (stat) {
      const statName = this.getStatName(stat.stat);
      return stat.display_name_override !== ``
        ? stat.display_name_override
        : this.stats[0][statName]
          ? this.stats[0][statName].display_name
          : this.stats[1][statName]
            ? this.stats[1][statName].display_name
            : null;
    },
  },
};
